import React, { useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Drawer,
  Box,
  TextField,
  Grid,
  CircularProgress
} from "@mui/material";
import PaginationComp from "../../../Pagination/PaginationComp";

const SandboxDepositsTable = ({
  merchant,
  message,
  page,
  totalPage,
  setPage,
  ReadData,
  authRead,
  authDelete,
  authUpdate,
  refundCharges,
  loading
}) => {

  const currencyFlags = {
    ARS: "arsflag.svg",
    AZN: "aznflag.svg",
    COP: "copflag.svg",
    EGP: "egpflag.svg",
    GHC: "ghcflag.svg",
    IDR: "idrflag.svg",
    INR: "inrflag.svg",
    JPY: "jpyflag.svg",
    KZT: "kztflag.svg",
    KGS: "kgsflag.svg",
    PHP: "phpflag.svg",
    BDT: "bdtflag.svg",
    BRL: "brlflag.svg",
    CLP: "clpflag.svg",
    CNY: "cnyflag.svg",
    CRC: "crcflag.svg",
    EUR: "euroflag.svg",
    GTQ: "gtqflag.svg",
    KRW: "krwflag.svg",
    KES: "kesflag.svg",
    LAK: "lakflag.svg",
    MXN: "mxnflag.svg",
    MYR: "myrflag.svg",
    NGN: "ngnflag.svg",
    PEN: "penflag.svg",
    PKR: "pkrflag.svg",
    THB: "thbflag.svg",
    UGX: "ugxflag.svg",
    USD: "usdflag.svg",
    USDT: "usdflag.svg",
    VND: "vndflag.svg",
    ZAR: "zarflag.svg",
    PLN: "plnflag.svg",
    RUB: "rubflag.svg",
    SGD: "sgdflag.svg",
    TRY: "tryflag.svg",
    UAH: "uahflag.svg",
    GBP: "gbpflag.svg",
    UZS: "uzsflag.svg",
    BIF: "bifflag.svg",
    XAF: "xafflag.svg",
    TZSHS: "tzshsflag.svg",
    ZMW: "zmwflag.svg",
    AED: "uaeflag.svg",
    MDL: "mdlflag.svg",
    XOF: "xofflag.svg",
    RWF: "rwfflag.svg",
  };

  const getCurrencyFlag = (currencyCode) => {
    try {
      return require(`../../../assets/currencyFlags/${currencyFlags[currencyCode]}`);
    } catch (err) {
      console.error(`Error loading flag for ${currencyCode}:`, err);
      return null; 
    }
  };

  return (
    <>
      <div style={{ maxHeight: "calc(100vh - 180px)", overflowY: "auto", marginTop: "16px", position: "relative" }}>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" my={3}>
            <CircularProgress sx={{color: "#ff6600"}} />
          </Box>
        ) : (
          <Table
            stickyHeader
            sx={{
              mt: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
              "& th, & td": {
                padding: "10px 12px",
                fontSize: "13.5px",
              },
            }}
          >
            <TableHead
              sx={{
                backgroundColor: "#f1f5f9",
                position: "sticky",
                top: 0,
                zIndex: 1,
                "& th": {
                  fontWeight: 600,
                  color: "#1f2937",
                  textTransform: "uppercase",
                  fontSize: "12px",
                  borderBottom: "1px solid #e0e0e0",
                  backgroundColor: "#f1f5f9",
                  whiteSpace: 'nowrap'
                },
              }}
            >
              <TableRow>
                {[
                  "Deposits",
                  "Customer Details",
                  "Currency",
                  "Status",
                  "Method",
                  "Requested Amount",
                  "Paid Amount",
                  "Charges",
                  "Settled Amount",
                  "Created On",
                  "Updated On",
                  "Action",
                ].map((heading) => (
                  <TableCell key={heading}>
                    <Typography
                      variant="h6"
                    >
                      {heading}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {merchant.map((merchant, index) => (
                <TableRow
                  sx={{
                    backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9f9f9",
                    "&:hover": {
                      backgroundColor: "#f1f1f1",
                    },
                  }}
                >
                  <TableCell>
                    <Typography
                      variant="h6"
                      sx={{
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <span style={{ color: "#1eaae7"}}>ORDER ID : {merchant.txn_id}</span><br />
                      <span style={{ color: "#6861CE"}}>UTR NO. : {merchant.reference ? merchant.reference : 'NA'}</span><br />
                      <span style={{ color: "#ff9800"}}>MER. No. : {merchant.user_id}</span>
                      {/* <span style={{ color: "#ff9800"}}>MER. No. : ({merchant.user_id}) {merchant.name}</span> */}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      sx={{
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <span style={{ color: "#1eaae7"}}>NAME: {merchant.i_flname}</span><br />
                      <span style={{ color: "#6861CE" }}>EMAIL: {merchant.i_email}</span><br />
                      <span style={{ color: "#ff9800"}}>MOBILE: {merchant.i_number}</span>
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      sx={{
                        textAlign: "center"
                      }}
                      variant="h6"
                    >
                        <img src={getCurrencyFlag(merchant.ammount_type)} alt={merchant.ammount_type} width="30px" /> &nbsp;&nbsp;
                      {merchant.ammount_type}
                    </Typography>
                  </TableCell>
                  
                  <TableCell>
                    <Typography
                      sx={{
                          color: 
                            merchant.status === 0
                          ? "red"
                          : merchant.status === 1
                          ? "green"
                          : merchant.status === 2
                          ? "orange"
                          : merchant.status === 3
                          ? "blue"
                          : merchant.status === 4
                          ? "pink"
                          : merchant.status === 5
                          ? "purple"
                          : "gray",
                          textTransform: "uppercase"
                      }}
                      variant="h6"
                    >
                      {
                        merchant.status === 0
                        ? "Failed"
                        : merchant.status === 1
                        ? "Success"
                        : merchant.status === 2
                        ? "Waiting"
                        : merchant.status === 3
                        ? "Pending"
                        : merchant.status === 4
                        ? "Refund"
                        : merchant.status === 5 
                        ? "ChargeBack"
                        : "Chargeback Settled"
                      }
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.payment_type}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.txn_amount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.ammount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {parseFloat(merchant.payin_charges).toFixed(2)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                      style={{textAlign: "center"}}
                    >
                      {merchant.settle_amount}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.created_on}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="h6"
                    >
                      {merchant.updated_on}
                    </Typography>
                  </TableCell>             
                  <TableCell align="center">
                    {authRead ? (
                      <ViewDrawer item={merchant} authRead={authRead} refundCharges={refundCharges} />
                    ) : "No Permssion"}
                  </TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell colSpan={12} align="center">
                  
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        )}
      </div>
      <PaginationComp
        setPage={setPage}
        page={page}
        totalPage={totalPage}
        message={message}
        disabled={loading}
      />
    </>
  );
};

const ViewDrawer = ({ item, authRead, refundCharges }) => {
  const [state, setState] = useState({ right: false });

  const toggleDrawer = (open) => () => {
    setState({ right: open });
    if (open) {
        // console.log(item)
    } else {
      // window.location.reload();
    }
  };

  const statusMap = {
    0: "FAILED",
    1: "SUCCESS",
    2: "WAITING",
    3: "PENDING",
    4: "REFUND",
    5: "CHARGEBACK",
    6: "REFUND INITIATED"
  };


  return (
    <div>
      {authRead && (
        <button
          className="btn btn-secondary btn-sm"
          onClick={toggleDrawer(true)}
        >
          View
        </button>
      )}
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)} PaperProps={{ style: { zIndex: 3 }, }}>
        <Box role="presentation" sx={{ width: {xs: 300, sm: 500} }}>
          <div style={{ padding: "20px", position: "relative" }}>
            <h4>TRANSACTION DETAILS</h4>
            <button
              style={{
                position: "absolute",
                top: "22px",
                right: "10px",
                background: "#ff6600",
                border: "none",
                borderRadius: "50%",
                cursor: "pointer",
                padding: "5px",
                width: "25px",
                height: "25px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
              onClick={toggleDrawer(false)}
            >
              <svg
                xmlns="http://www .org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-x"
                style={{
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <Grid container spacing={2}>
              {[
                { label: "ORDER NO.", value: item?.txn_id || "NOT AVAILABLE" },
                { label: "TRANSACTION STATUS", value: statusMap[item?.status] || "NOT AVAILABLE" },
                { label: "PAYEE NAME", value: item?.i_flname || "NOT AVAILABLE" },
                { label: "EMAIL", value: item?.i_email || "NOT AVAILABLE" },
                { label: "MOBILE", value: item?.i_number || "NOT AVAILABLE" },
                { label: "BILLING ADDRESS", value: item?.bill_address || "NOT AVAILABLE" },
                { label: "CITY", value: item?.i_city || "NOT AVAILABLE" },
                { label: "STATE", value: item?.i_state || "NOT AVAILABLE" },
                { label: "COUNTRY", value: item?.i_country || "NOT AVAILABLE" },
                { label: "ZIP CODE", value: item?.i_zip || "NOT AVAILABLE" },
                { label: "CURRENCY", value: item?.ammount_type || "NOT AVAILABLE" },
                { label: "TYPE", value: item?.payment_type || "NOT AVAILABLE" },
                { label: "REQUESTED AMOUNT", value: item?.ammount || "NOT AVAILABLE" },
                { label: "CHARGES", value: item?.payin_charges || "NOT AVAILABLE" },
                { label: "SETTLED AMOUNT", value: item?.settle_amount || "NOT AVAILABLE" },
              ].map((field, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <TextField
                    label={field.label}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={field.value}
                    InputProps={{ readOnly: true, style: { zIndex: 4} }}
                    disabled
                  />
                </Grid>
              ))}

                {/* {
                  item.status === 1 ? (
                    <Grid item xs={12} sm={6}>
                      <RefundDrawer item={item} refundCharges={refundCharges} />
                    </Grid>
                  ) : ""
                } */}
            </Grid>

          </div>
        </Box>
      </Drawer>
    </div>
  );
};

export default SandboxDepositsTable;